// extracted by mini-css-extract-plugin
export var lg = "_ds-7";
export var md = "_ds-6";
export var placeholderContainer = "_ds-1";
export var placeholderIcon = "_ds-2";
export var productImage = "_ds-0";
export var sm = "_ds-5";
export var xl = "_ds-8";
export var xs = "_ds-4";
export var xxs = "_ds-3";